import angular from "angular";
import TemplateSelectorPageComponent from "./template-selector-page/template-selector-page";
import QuoteTemplateImportModalComponent from "./quote-template-import-modal/quote-template-import-modal";
import QuoteTemplateEditNameModalComponent from "./quote-template-edit-name-modal/quote-template-edit-name-modal";
import QuoteTemplateShareModalComponent from "./quote-template-share-modal/quote-template-share-modal";

const TemplateSelectorModule = angular
  .module("modules.templateSelector", [])
  .component("templateSelectorPage", TemplateSelectorPageComponent)
  .component("quoteTemplateImportModal", QuoteTemplateImportModalComponent)
  .component("quoteTemplateEditNameModal", QuoteTemplateEditNameModalComponent)
  .component("quoteTemplateShareModal", QuoteTemplateShareModalComponent);

export default TemplateSelectorModule;
